import { combineReducers } from "redux";
import { JENIS_CONSIGNEE_BERANGKAT_GET_SUCCESS } from "../actions/jenisConsigneeBerangkatAction";

const jenisConsigneeBerangkat = (
  state = { isLoad: false, value: [], msg: "" },
  action
) => {
  switch (action.type) {
    case JENIS_CONSIGNEE_BERANGKAT_GET_SUCCESS:
      return { value: action.val, isLoad: action.load, msg: action.msg };
    default:
      return state;
  }
};

const jenisConsigneeBerangkatReducer = combineReducers({
  jenisConsigneeBerangkat,
});

export default jenisConsigneeBerangkatReducer;
